import InviteFriendsRewards from './InviteFriendsRewards/InviteFriendsRewards';
import SocialMediaButtons from './SocialMediaButtons/SocialMediaButtons';
import YourUniqueLink from './YourUniqueLink/YourUniqueLink';
import LinkField from './LinkField/LinkFIeld';
import { Box, Image, Text } from '@bonanza-social/moonlight';
import { Promo } from '@bonanza-social/promos';

function AvailableReferrerPromo({ referrerPromo }: { referrerPromo: Promo }) {
  return (
    <Box
      flex={1}
      flexDirection="column"
      justifyContent="space-between"
      paddingBottom="safe-area-inset-bottom"
    >
      <Box gap="space-200">
        <Image
          source={referrerPromo?.bannerImageUrl}
          borderTopLeftRadius="radius-400"
          borderTopRightRadius="radius-400"
          width="100%"
          aspectRatio={2}
          contentFit="cover"
        />
        <YourUniqueLink
          playerExecutionCount={referrerPromo.playerExecutionCount}
          playerExecutionLimit={referrerPromo.playerExecutionLimit}
        />
        <Text
          variant="h5"
          gradient="darkSurfaceAccent"
          locNS="inviteFriends"
          locKey="invite_friends_title"
        />
        <Text
          variant="body-s"
          color="darkSurfacePrimary"
          locNS="inviteFriends"
          locKey="invite_friends_desc"
        />
        <InviteFriendsRewards
          rewards={referrerPromo.rewards}
          refereeRewards={referrerPromo.refereeRewards}
          promoType={referrerPromo.promoType}
        />
      </Box>
      <Box gap="space-200" marginTop="space-500">
        <LinkField referralCode={referrerPromo?.referralCode} />
        <SocialMediaButtons referralCode={referrerPromo?.referralCode} />
        <Text
          variant="body-s"
          color="darkSurfacePrimary"
          locNS="inviteFriends"
          locKey="invite_friends_terms"
        />
      </Box>
    </Box>
  );
}

export default AvailableReferrerPromo;
